// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__2pfiy","spinner-sm":"Spinner_spinner-sm__EyDyx","s3":"Spinner_s3__YQCF3","spinner-red":"Spinner_spinner-red__sf6ZS"};